var exports = {
  "iE": "xfd349460--0db248--wrapper",
  "Kk": "xfd349460--0db248--icon",
  "DD": "xfd349460--0db248--title",
  "iU": "xfd349460--0db248--message",
};

module.exports = exports;
